import React, { useEffect, useState } from "react";
import TableOne from "../table/TableOne";
import { getRequest, deleteRequest } from "../api/api";
import {
  Modal,
  Form,
  Input,
  Upload,
  Button,
  Select,
  message,
  Row,
  Col,
  Switch,
} from "antd";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import "./../style/common.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ChapterSlideModal from "../components/ChapterSlideModal";
import { FaPlus } from "react-icons/fa6";
import { FaEdit } from "react-icons/fa";
import { SiBookstack } from "react-icons/si";
import ReactDOMServer from "react-dom/server";
import { FaTrash, FaTimes } from "react-icons/fa";
import { IoDuplicateOutline } from "react-icons/io5";

const Chapter = () => {
  const [chapters, setChapters] = useState([]);
  const [modules, setModules] = useState([]);
  const [submodules, setSubmodules] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editingChapter, setEditingChapter] = useState(null);
  const [authors, setAuthors] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [slideModalVisible, setSlideModalVisible] = useState(false);
  const [selectedChapterForSlide, setSelectedChapterForSlide] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();
// Copy modal state
const [copyVisible, setCopyVisible] = useState(false);
const [copyLoading, setCopyLoading] = useState(false);
const [copyForChapter, setCopyForChapter] = useState(null);
const [copyModuleId, setCopyModuleId] = useState(null);
const [copySubmoduleId, setCopySubmoduleId] = useState(null);
const [copyTitle, setCopyTitle] = useState("");
const [copySubs, setCopySubs] = useState([]); // submodules for selected module in copy modal


  const navigate = useNavigate();

  console.log("setSelectedChapterForSlide", setSelectedChapterForSlide);

  const getChapters = async () => {
    setLoading(true);
    try {
      const response = await getRequest("chapters?all=true&isModule=true&isSubModule=true");
      setChapters(response);
      const uniqueAuthors = [
        ...new Set(response.map((item) => item.author_name).filter(Boolean)),
      ];
      setAuthors(uniqueAuthors);
    } catch (error) {
      console.error("Error fetching chapters:", error);
    } finally {
      setLoading(false); // stop loading
    }
  };

  const getModules = async () => {
    try {
      const response = await getRequest("modules?all=true");
      setModules(response);
    } catch (error) {
      console.error("Error fetching modules:", error);
    }
  };

  const getSubmodules = async (moduleId) => {
    try {
      const response = await getRequest(`submodules/module/${moduleId}`);
      setSubmodules(response);
    } catch {
      setSubmodules([]);
    }
  };

  useEffect(() => {
    getChapters();
    getModules();
  }, []);

  const handleDelete = async (chapter) => {
const result = await Swal.fire({
  title: `Are you sure?`,
  html: `This will permanently delete <b>${chapter.title}</b>.`,
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: "#d33",
  cancelButtonColor: "#3085d6",
  confirmButtonText: ReactDOMServer.renderToString(
    <>
      <FaTrash style={{ marginRight: 6 }} /> Yes, delete it!
    </>
  ),
  cancelButtonText: ReactDOMServer.renderToString(
    <>
      <FaTimes style={{ marginRight: 6 }} /> Cancel
    </>
  ),
  allowOutsideClick: false,
});

    if (result.isConfirmed) {
      try {
        await deleteRequest(`chapters/${chapter.id}`);
        message.success("Chapter deleted");
        getChapters();
      } catch (error) {
        message.error("Failed to delete");
      }
    }
  };

  const handleEdit = (chapter) => {
    setEditMode(true);
    setEditingChapter(chapter);
    form.setFieldsValue({
      module_id: chapter?.module_id,
      sub_module_id: chapter?.sub_module_id || null,
      title: chapter?.title,
      description: chapter?.description,
      is_active: chapter?.is_active === 1 || chapter?.is_active === "1", // ✅ prefill boolean
      author_name: chapter?.author_name,
      image: chapter?.image
        ? [
            {
              uid: "-1",
              name: "existing image",
              status: "done",
              url: chapter.image,
            },
          ]
        : [],
    });
    getSubmodules(chapter.module_id);
    setModalVisible(true);
  };

  const handleAdd = () => {
    setEditMode(false);
    form.resetFields();
    setModalVisible(true);
  };

  const handleFormSubmit = async (values) => {
    setSaving(true);
    const formData = new FormData();
    formData.append("module_id", values?.module_id);
    formData.append("sub_module_id", values?.sub_module_id || "");
    formData.append("title", values?.title);
    formData.append("description", values?.description || "");
    formData.append("author_name", values?.author_name);
    const isActiveToSend = editMode ? (values?.is_active ? 1 : 0) : 1; // add default 1 on create
    formData.append("is_active", isActiveToSend);

    if (values.image && values.image[0]?.originFileObj) {
      formData.append("image", values.image[0].originFileObj);
    }

    const endpoint = editMode
      ? `https://pranafreshharvest.com/api/chapters/${editingChapter.id}`
      : "https://pranafreshharvest.com/api/chapters";
    const method = editMode ? "post" : "post";

    const token = localStorage.getItem("token");

    try {
      const response = await axios({
        method,
        url: endpoint,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        message.success(
          `Chapter ${editMode ? "updated" : "added"} successfully`
        );

        // ✅ Add newly typed author to authors list if not already included
        if (!authors.includes(values.author_name)) {
          setAuthors((prev) => [...prev, values.author_name]);
        }

        setModalVisible(false);

        // Optional: Reset other fields but keep author_name if needed
        // form.resetFields(["module_id", "sub_module_id", "title", "description", "image"]);
        // OR simply reload all chapters (which resets authors anyway)
        getChapters();
      } else {
        message.error("Failed to save chapter");
      }
    } catch (error) {
      message.error("Something went wrong");
      console.error("Axios error:", error.response || error);
    } finally {
      setSaving(false);
    }
  };

 const handleCopyChapter = (chapter) => {
  setCopyForChapter(chapter);
  setCopyModuleId(null);
  setCopySubmoduleId(null);
  setCopyTitle("");        // user may leave blank (we'll send null)
  setCopySubs([]);
  setCopyVisible(true);
};

const loadCopySubmodules = async (moduleId) => {
  try {
    const res = await getRequest(`submodules/module/${moduleId}`);
    setCopySubs(Array.isArray(res) ? res : []);
  } catch {
    setCopySubs([]);
  }
};


const submitCopy = async () => {
  if (!copyForChapter) return;

  // basic validation
  if (!copyModuleId) {
    return message.warning("Please select a Module.");
  }

  const token = localStorage.getItem("token");
  const payload = {
    module_id: copyModuleId,
    sub_module_id: copySubmoduleId || null,
    title: copyTitle?.trim() ? copyTitle.trim() : null, // send null if empty
    is_active: true,
    copy_image: true,
    copy_slide_files: true,
    only_active_slides: true,
    only_active_mcqs: true,
  };

  setCopyLoading(true);
  try {
    await axios.post(
      `https://pranafreshharvest.com/api/chapters/${copyForChapter.id}/duplicate-to-module`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    message.success("Chapter duplicated successfully");
    setCopyVisible(false);
    setCopyForChapter(null);
    // refresh list
    getChapters();
  } catch (err) {
    console.error(err);
    message.error("Failed to duplicate chapter");
  } finally {
    setCopyLoading(false);
  }
};


  const columns = [
    {
      title: "Sr. No.",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (value) => {
        const fallbackImage =
          "/defualt-img.png";

        const imageUrl = value && value.trim() !== "" ? value : fallbackImage;

        return (
          <img
            src={imageUrl}
            alt={value ? "Chapter Image" : "Default Image"}
            width={60}
            height={40}
            style={{ cursor: "pointer", borderRadius: 4, objectFit: "cover" }}
            onClick={() => {
              setPreviewImage(imageUrl); // Make sure these are in your component's state
              setPreviewVisible(true);
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = fallbackImage;
            }}
          />
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Author",
      dataIndex: "author_name",
      key: "author_name",
    },
    {
      title: "Module",
      dataIndex: ["module", "name"], // supports nested access
      key: "module",
      render: (_, record) => record.module?.name || "-",
    },
    {
      title: "Submodule",
      dataIndex: ["submodule", "name"],
      key: "submodule",
      render: (_, record) => record.submodule?.name || "-",
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      render: (value) => {
        const isActive = value === 1 || value === "1";
        return (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              color: isActive ? "#10b981" : "#ef4444",
              fontWeight: "500",
            }}
          >
            <span
              style={{
                height: "8px",
                width: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10b981" : "#ef4444",
                display: "inline-block",
              }}
            />
            {isActive ? "Active" : "Inactive"}
          </span>
        );
      },
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <div className="header-button">
        <h2
          style={{
            color: "#5a355a",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            lineHeight: 1,
          }}
        >
          <SiBookstack />
          <span>Chapter</span>
          <span
            style={{
              color: "#979797ff",
              fontSize: "14px",
              fontWeight: 500,
              alignSelf: "flex-end", // bottom-align just the total
            }}
          >
            (Total: {chapters?.length ?? 0})
          </span>
        </h2>
        <Button
          type="primary"
          onClick={handleAdd}
          icon={<PlusOutlined />}
          style={{ marginBottom: 20 }}
          className="add-btn"
        >
          Add Chapter
        </Button>
      </div>

      <TableOne
        columns={columns}
        data={chapters}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        handleCopyChapter={handleCopyChapter}
        handleAddSlide={(chapter) =>
          navigate("/chapter-slides", {
            state: { selectedChapter: chapter },
          })
        }
        pageName="chapter"
        loading={loading}
        searchExcludeFields={["description"]}
      />

      <Modal
        title={editMode ? "Update Chapter" : "Add Chapter"}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        destroyOnClose
        width={700}
        maskClosable={false}
      >
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="module_id"
                label="Module"
                rules={[{ required: true, message: "Required Module Name" }]}
              >
                <Select
                  placeholder="Select Module"
                  showSearch
                  onChange={getSubmodules}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {modules.map((mod) => (
                    <Select.Option key={mod.id} value={mod.id}>
                      {mod.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="sub_module_id" label="Submodule (Optional)">
                <Select
                  placeholder="Select Submodule"
                  allowClear
                  showSearch
                  notFoundContent="-"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {submodules.map((sub) => (
                    <Select.Option key={sub.id} value={sub.id}>
                      {sub.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="title"
            label="Chapter Title"
            rules={[{ required: true, message: "Required Chapter Title" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="author_name"
            label="Author Name"
            rules={[{ required: true, message: "Required author name" }]}
          >
            <Select
              placeholder="Select or Enter Author"
              showSearch
              allowClear
              optionFilterProp="children"
              mode="combobox"
              onChange={(value) => {
                form.setFieldsValue({ author_name: value });
              }}
              onBlur={(e) => {
                const typedValue = e.target.value;
                if (typedValue) {
                  form.setFieldsValue({ author_name: typedValue });
                }
              }}
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {authors.map((name, index) => (
                <Select.Option key={index} value={name}>
                  {name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="description" label="Description">
            <Input.TextArea rows={3} style={{ minHeight: "120px" }} />
          </Form.Item>

          <Form.Item
            name="image"
            label="Image"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
          >
            <Upload
              listType="picture"
              maxCount={1}
              beforeUpload={() => false}
              accept="image/*"
            >
              <Button icon={<UploadOutlined />}>Upload Image</Button>
            </Upload>
          </Form.Item>

          {editMode && (
            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const on = !!getFieldValue("is_active");
                return (
                  <Form.Item
                    name="is_active"
                    label="Status"
                    valuePropName="checked"
                    className="custom-form-label"
                  >
                    <Switch
                      checkedChildren="Active"
                      unCheckedChildren="Inactive"
                      className={`status-switch ${on ? "on" : "off"}`}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          )}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              icon={editMode ? <FaEdit /> : <FaPlus />}
              loading={saving}
            >
              {editMode ? "Update Chapter" : "Add Chapter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        open={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
      >
        <img
          alt="Preview"
          style={{ width: "100%", borderRadius: 4 }}
          src={previewImage}
        />
      </Modal>

      <ChapterSlideModal
        visible={slideModalVisible}
        chapter={selectedChapterForSlide}
        onClose={() => setSlideModalVisible(false)}
        onSuccess={getChapters}
      />


<Modal
  open={copyVisible}
  title="Copy Chapter to Module"
  onCancel={() => setCopyVisible(false)}
  onOk={submitCopy}
  okText={copyLoading ? "Copying..." : "Copy"}
  confirmLoading={copyLoading}
  destroyOnClose
  width={560}
>
  <div style={{ display: "grid", gap: 16 }}>
    <div>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>Select Module</div>
      <Select
        placeholder="Choose Module"
        showSearch
        value={copyModuleId}
        onChange={(val) => {
          setCopyModuleId(val);
          setCopySubmoduleId(null);
          loadCopySubmodules(val);
        }}
        style={{ width: "100%" }}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
      >
        {modules.map((m) => (
          <Select.Option key={m.id} value={m.id}>
            {m.name}
          </Select.Option>
        ))}
      </Select>
    </div>

    <div>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>
        Select Submodule <span style={{ color: "#888", fontWeight: 400 }}>(Optional)</span>
      </div>
      <Select
        placeholder="Choose Submodule (optional)"
        allowClear
        value={copySubmoduleId}
        onChange={(val) => setCopySubmoduleId(val || null)}
        style={{ width: "100%" }}
        notFoundContent="-"
        disabled={!copyModuleId}
        showSearch
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
      >
        {copySubs.map((s) => (
          <Select.Option key={s.id} value={s.id}>
            {s.name}
          </Select.Option>
        ))}
      </Select>
    </div>

    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Title (Optional)</div>
        <Button type="link" onClick={() => setCopyTitle("")}>
          Skip Title
        </Button>
      </div>
      <Input
        placeholder="Enter new title or leave blank to copy as it is."
        value={copyTitle}
        onChange={(e) => setCopyTitle(e.target.value)}
        allowClear
      />
    </div>


  </div>
</Modal>


    </div>
  );
};

export default Chapter;
